import React from 'react';
import { AdminRouteName } from '../../CONSTANTS';
import RepaymentTableRecords from '../RepaymentTableRecords';

const DefaultRepayments = () => (
  <RepaymentTableRecords defaultUrl={AdminRouteName.defaultRepaymentRoute} tabStatus="DEFAULTING" toggleStorageId="default-repayment-table-col" hasNameAndImage permissionName="can-view-defaulting-repayments" />

);

export default DefaultRepayments;
